import none from '../../img/leoLogo.png'

export const vegan=[
    {
      "id": "241",
      "title": "vegetarian burger",
      "desciption": "",
      "price": "260",
      "image": none
    },
    {
      "id": "242",
      "title": "herbal schnitze",
      "desciption": "",
      "price": "250",
      "image": none
    },
    {
      "id": "243",
      "title": "vegetable salad",
      "desciption": "",
      "price": "210",
      "image": none
    },
    
  ]